<script>
  export let class_;
  console.log("ITEM HEADER");
  console.log(class_);
</script>

<div class="th  border-b border-gray-100 font-semibold text-gray-600">
  {#if /timber|foam|board|pine/.test(class_)}
    <!-- content here -->
    <h1 style="min-width: 15rem; max-width: 15rem;">Actions</h1>
    <h1 style="min-width: 15rem; max-width: 15rem;">Name</h1>
    <div style="min-width: 10rem; max-width: 10rem;">Last Stock Take</div>
    <div style="min-width: 6rem; max-width: 6rem;">Quantity</div>
    <div style="min-width: 6rem; max-width: 6rem;">Plank Price</div>
    <div style="min-width: 10rem; max-width: 10rem;">Lot Number</div>
    <div style="min-width: 6rem; max-width: 6rem;">Length</div>
    <div style="min-width: 6rem; max-width: 6rem;">Width</div>
    <div style="min-width: 6rem; max-width: 6rem;">Thickness</div>
    <div style="min-width: 6rem; max-width: 6rem;">Bundle Price</div>
    <div style="min-width: 7.5rem; max-width: 7.5rem;">Total MM</div>
    <div style="min-width: 6rem; max-width: 6rem;">SKU</div>
    <div style="min-width: 7.5rem; max-width: 7.5rem;">Plank Number</div>
  {:else}
    <h1 style="min-width: 15rem; max-width: 15rem;">Actions</h1>
    <h1 style="min-width: 20rem; max-width: 20rem;">Name</h1>
    <div style="min-width: 10rem; max-width: 10rem;">Last Stock Take</div>
    <h1 class="cursor-pointer mr-4" style="min-width: 6rem; max-width: 6rem;">
      Price (Rands)
    </h1>
    <div style="min-width: 7.5rem; max-width: 7.5rem;">Quantity</div>

    <h1 class="mr-4 text-gray-500" style="min-width: 6rem; max-width: 6rem;">
      Price Average
    </h1>
    <div style="min-width: 7.5rem; max-width: 7.5rem;">EOQ</div>
    <div style="min-width: 10rem; max-width: 10rem;">SKU</div>
    <div style="min-width: 10rem; max-width: 10rem;">Supplier</div>
    {#if class_ == "fabric"}
      <div style="min-width: 7rem; max-width: 7rem;">Material Provider</div>
    {/if}
    <div style="min-width: 7.5rem; max-width: 7.5rem;">Total Value</div>
  {/if}
</div>

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
